import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}
Vue.use(VueRouter)

const routes = require('./office.js').default;

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// 将路由的path提取出来
const routerArray = (arr) => {
	return arr.map(item => {
		if (item.url) {
			return item.url;
		} else {
			return routerArray(item.menus);
		}
	})
}

router.beforeEach((to, from, next) => {
	// 先判断是否登录
	if (to.meta.index > 0 && !store.getters.getUserInfo) {
		next('/');
		return;
	}
	if (to.meta.index == 0) {
		next();
		return;
	}
	// 如果能获取到菜单，则判断权限
	if (store.getters.getMenu) {
		if (to.name == 'home' || to.meta.index > 1) {
			next();
			return;
		}
		// 将path整合到一维数组
		let menus = routerArray(store.getters.getMenu).reduce((a, b) => {
			if (typeof a != 'object') {
				a = [a];
			}
			if (typeof b != 'object') {
				b = [b];
			}
			return a.concat(b)
		})
		if (menus.filter(item => item == to.path).length > 0) {
			next();
		} else {
			next('/403')
		}
	} else {
		next()
	}
})

export default router
